import State from 'store/State';
import { selectStreamState } from 'streamsState/store/selectors';
import {
    StreamStatus,
    StreamStatusState,
} from 'streamsState/store/streamStatuses/StreamStatusesState';

export const selectStreamStatusesState = (state: State) =>
    selectStreamState(state).statuses;

export const selectStreamDataStreamState = (state: State, streamKey: string) =>
    selectStreamStatusesState(state).streams[streamKey];

export const selectChannelId = (state: State, streamKey?: string) => {
    if (!streamKey) {
        return;
    }
    const streamState = selectStreamDataStreamState(state, streamKey);
    return streamState ? streamState.channelId : undefined;
};

export const selectAllStreamKeys: (state: State) => string[] = (state) =>
    Object.keys(selectStreamStatusesState(state).streams);

export const selectAllStreamStatuses: (
    state: State
) => { streamKey: string; status: StreamStatusState }[] = (state) => {
    const streamKeys = selectAllStreamKeys(state);
    return streamKeys.map((streamKey) => ({
        streamKey,
        status: selectStreamStatusesState(state).streams[streamKey],
    }));
};

export const selectAllStoppedStreamStatuses: (state: State) => {
    streamKey: string;
    stoppedTime: number;
}[] = (state) => {
    return selectAllStreamStatuses(state)
        .filter((s) => s.status.status === StreamStatus.STOPPED)
        .map((s) => ({
            streamKey: s.streamKey,
            stoppedTime: s.status.statusTime,
        }));
};
